export const BANNER_KEY = "BANNER";

export const BANNER_CACHE_KEYS = {
  LIST: [BANNER_KEY, "LIST"] as const,
  UPLOAD_IMAGE: [BANNER_KEY, "UPLOAD_IMAGE"] as const,
};
